"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDate = void 0;
/* eslint-disable react/require-default-props, import/no-cycle */
var react_1 = __importStar(require("react"));
var icons_1 = require("@ant-design/icons");
var date_fns_1 = require("date-fns");
var FilterBar_1 = __importDefault(require("../Elements/FilterBar"));
var BreadcrumbBar_1 = __importDefault(require("../Elements/BreadcrumbBar"));
var Async_1 = __importDefault(require("../../Table/Async"));
var TextInput_1 = __importDefault(require("../../Form/Elements/TextInput"));
var style_1 = require("./style");
var PageContainer_1 = __importDefault(require("../Elements/PageContainer"));
var ContentContainer_1 = __importDefault(require("../Elements/ContentContainer"));
exports.defaultDate = {
    start: date_fns_1.startOfToday(),
    end: date_fns_1.endOfToday(),
};
var TableView = function (_a) {
    var _b = _a.hasFilterBar, hasFilterBar = _b === void 0 ? false : _b, _c = _a.hasSearch, hasSearch = _c === void 0 ? false : _c, ActionBar = _a.ActionBar, breadcrumbBar = _a.breadcrumbBar, queryTableProps = _a.queryTableProps;
    var _d = react_1.useState([]), selectedRowKeys = _d[0], setSelectedRowKeys = _d[1];
    var _e = react_1.useState(""), searchString = _e[0], setSearchString = _e[1];
    var _f = react_1.useState([]), filterValues = _f[0], setFilterValues = _f[1];
    var updateSearchString = react_1.useCallback(function (_a) {
        var value = _a.currentTarget.value;
        setSearchString(value);
    }, []);
    var updateFilterValues = react_1.useCallback(function (fv) {
        setFilterValues(fv);
    }, []);
    var asyncTableProps = __assign(__assign({}, queryTableProps), { tableProps: __assign(__assign({}, queryTableProps.tableProps), { antdTableProps: __assign(__assign({}, queryTableProps.tableProps.antdTableProps), { rowSelection: {
                    selectedRowKeys: selectedRowKeys,
                    type: "checkbox",
                    onChange: function (sRowKeys) {
                        setSelectedRowKeys(sRowKeys);
                    },
                } }) }), filterValues: filterValues });
    return (react_1.default.createElement(PageContainer_1.default, null,
        react_1.default.createElement(BreadcrumbBar_1.default, __assign({}, breadcrumbBar)),
        react_1.default.createElement(ContentContainer_1.default, null,
            hasFilterBar && (react_1.default.createElement(FilterBar_1.default, { canExpand: false, filterValues: filterValues, onChange: updateFilterValues })),
            react_1.default.createElement(style_1.TableContainer, null,
                selectedRowKeys.length > 0 && ActionBar
                    ? ActionBar
                    : hasSearch && (react_1.default.createElement(style_1.SearchContainer, null,
                        react_1.default.createElement(TextInput_1.default, { value: searchString, onChange: updateSearchString, prefix: react_1.default.createElement(icons_1.SearchOutlined, null), placeholder: "Search" }))),
                react_1.default.createElement(Async_1.default, __assign({}, asyncTableProps))))));
};
exports.default = TableView;
